export default "__VITE_ASSET__abed4663__"